if (!customElements.get('country-switcher-modal')) {
  const { Fancybox } = await import('@fancyapps/ui');
  class CountrySwitcherModal extends HTMLElement {

    #toBoolean(str) {
      return String(str).toLowerCase() === 'true';
    }

    constructor() {
      super();

      this.anchors = this.querySelectorAll('[data-iso]');
      this.popup = this.querySelector('[data-country-switcher-content]');
      this.triggers = document.querySelectorAll('[data-country-switcher-modal-trigger]');
      this.fancybox = null;

      // Trigger the modal
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Add the search URL to the ISO anchors
      let searchUrl = location.search;
      if (searchUrl) {
        this.anchors.forEach((anchor) => {
          let currentUrl = anchor.href;
          let newUrl = currentUrl + searchUrl;
          anchor.href = newUrl;
        });
      }
    }

    /**
     * Open the country switcher modal
     * @returns
     */
    open() {
      new Fancybox(
        [
          {
            src: this.popup.innerHTML,
            type: 'html',
            autoFocus: false,
            showClass: false,
            fullscreen: {
              autoStart: true,
            },
          },
        ],
        {
          mainClass: 'country-switcher-modal',
          on: {
            done: (fancybox) => {
              if (!fancybox?.$container) return;
              this.fancybox = fancybox.$container;
              this.fancybox.querySelectorAll('[data-iso]').forEach((anchor) => {
                anchor.addEventListener('click', (e) => {
                  e.preventDefault();
                  this.handleSwitch(
                    {
                      iso: anchor.dataset.iso,
                      url: anchor.href,
                      useMarkets: this.#toBoolean(anchor.dataset.useMarkets)
                    }
                  );
                });
              });
            },
          },
        },
      );
    }

    /**
     * Switch the store local (language & country)
     * @param {String} iso - The iso code of the language-Country (en-EN)
     * @param {String} url
     * @param {Boolean} useMarkets
     * @returns
     */
    handleSwitch({ iso, url, useMarkets = false }) {
      if (!iso || !url || !this.fancybox) return;
      this.setIso(iso);
      if (!useMarkets) {
        this.navigateToUrl(url);
      } else {
        const form = this.fancybox.querySelector('#country-switcher-form');
        let [language, country] = iso.split('-');
        if (language.endsWith('-dev')) {
          language = language.replace('-dev', '');
        }
        if (language === 'en' && window.location.href.includes('alpinestars-stage.myshopify.com')) {
          language = 'en-dev'
        }
        form.querySelector('input[name="language_code"]').setAttribute('value', language);
        form.querySelector('input[name="country_code"]').setAttribute('value', country);
        form.querySelector('input[type="submit"]').click();
      }
    }

    /**
     * Set the ISO storage
     * @param {String} iso - The iso code of the language-Country (en-EN)
     * @returns {Object} - The ISO storage
     * @example {iso: 'en-EN', timestamp: 1718000000}
     */
    setIso(iso) {
      if (!iso) return;
      const storage = {
        iso: iso,
        timestamp: Date.now(),
      };
      localStorage.setItem('preferred-locale', JSON.stringify(storage));
      return storage;
    }

    /**
     * Navigate to the url
     * @param {String} url - The url to navigate to
     * @returns
     */
    navigateToUrl(url) {
      window.location.href = url;
    }
  }

  window.CountrySwitcherModal = CountrySwitcherModal;

  customElements.define('country-switcher-modal', CountrySwitcherModal);
}
